import { render } from "./DataMapperInvocations.vue?vue&type=template&id=918e4282&scoped=true"
import script from "./DataMapperInvocations.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocations.vue?vue&type=script&lang=js"

import "./DataMapperInvocations.vue?vue&type=style&index=0&id=918e4282&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918e4282"]])

export default __exports__